import React from 'react';

/**
 * Modern Stat Card Component
 * Colorful gradient stat cards like in dashboard
 */
export const ModernStatCard = ({ 
  title, 
  value, 
  icon, 
  color = 'blue', 
  onClick,
  subtitle = null
}) => {
  const iconColors = {
    blue: 'bg-blue-100 dark:bg-blue-500/15 text-blue-700 dark:text-blue-300',
    emerald: 'bg-emerald-100 dark:bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
    amber: 'bg-amber-100 dark:bg-amber-500/15 text-amber-700 dark:text-amber-300',
    violet: 'bg-violet-100 dark:bg-violet-500/15 text-violet-700 dark:text-violet-300',
    red: 'bg-red-100 dark:bg-red-500/15 text-red-700 dark:text-red-300',
  };

  return (
    <div
      onClick={onClick}
      className={`bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 border border-gray-200 dark:border-white/10 rounded-xl p-4 ${onClick ? 'cursor-pointer' : ''} transition-all duration-200 group`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg ${iconColors[color]}`}>
          {icon}
        </div>
        {onClick && (
          <span className="text-gray-400 dark:text-slate-500 group-hover:text-gray-600 dark:group-hover:text-slate-400 transition-colors">→</span>
        )}
      </div>
      <div className="text-3xl font-bold text-gray-900 dark:text-white mb-1">{value}</div>
      <div className="text-gray-600 dark:text-slate-400 text-sm">{title}</div>
      {subtitle && (
        <div className="text-gray-500 dark:text-slate-500 text-xs mt-1">{subtitle}</div>
      )}
    </div>
  );
};

export default ModernStatCard;

